// Otto Repricer Service API calls
import axios from "axios";

const TICKETS_API_URL =
  import.meta.env.VITE_TICKETS_API_URL || "/api/v1/tickets";

// Create axios instance for Otto service
const ticketsApiClient = axios.create({
  baseURL: TICKETS_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to include auth token
ticketsApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Health check
export const ticketsHealthApi = {
  healthCheck: () => ticketsApiClient.get("/health"),
};

export default ticketsApiClient;
